import styled from 'styled-components';
import { Form as FormComponent } from '@unform/web';

import { colors } from '../../../../styles/tokens';

export const Form = styled(FormComponent)`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ResendLink = styled.button`
  align-self: center;

  background: transparent;
  border: none;

  color: ${colors.primary};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  cursor: pointer;
`;

export const BackLink = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px auto 0;

  background: transparent;
  border: none;

  color: ${colors.onSurfaceVariant};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    color: ${colors.onSurface};
  }
`;
